import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store/useStore';
import { userProfileSlice } from '../../../../store/userProfileSlice';
import { postMessageToRN } from '../../../../utils/RNCommunicator/postMessageToRN.util';

export const LogoutPage = () => {
  const dispatch = useAppDispatch();
  const userProfileActions = userProfileSlice.actions;
  const userProfileStates = useAppSelector((state) => state.userProfile);

  const navigate = useNavigate();

  const [loginPlatform, setLoginFlatform] = useState<'KAKAO' | 'APPLE'>(
    userProfileStates.userProfile?.oAuthPlatform === 'KAKAO' ? 'KAKAO' : 'APPLE',
  );

  const removeAccessToken = () => localStorage.removeItem('@accessToken');

  const resetUserProfile = () => dispatch(userProfileActions.resetUserProfile());

  const logout = () => {
    removeAccessToken();
    resetUserProfile();

    if (loginPlatform === 'KAKAO') {
      //   window.location.href = `https://kauth.kakao.com/logout?client_id=${process.env.REACT_APP_KAKAO_ClIENT_ID}&logout_redirect_uri=${window.location.origin}/oauth/login`;
      navigate('/oauth/login');
    } else {
      navigate('/oauth/login');
    }
  };

  useEffect(() => {
    if (window.ReactNativeWebView) {
      postMessageToRN({ messageKey: 'setUserId' });
    }

    logout();
  }, []);

  return <></>;
};
